// extracted by mini-css-extract-plugin
module.exports = {"container":"messagesList_container__1mbjo","separation":"messagesList_separation__p21Sa"};